import { Notification, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useValidationErrorsStore } from '@hero/components/providers/ValidationErrorsProvider';

const CollectionsWarningList = styled.ul`
  padding: 0 16px;
`;

const CollectionsWarningListItem = styled.li`
  list-style-type: disc;

  ${Typography.S.Typography} {
    text-transform: lowercase;
  }

  ${Typography.S.Typography}:first-letter {
    text-transform: uppercase;
  }
`;

function ValidationErrors({ pageLayoutContentRef, style }) {
  const { t } = useTranslation();

  const { counter, errors } = useValidationErrorsStore();

  const validationErrors = errors || {};
  const isOnlyOneError =
    Object.keys(validationErrors)?.length === 1 &&
    validationErrors?.[Object.keys(validationErrors)?.[0]]?.length === 1;

  useEffect(() => {
    if (Object.keys(validationErrors)?.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      pageLayoutContentRef?.current?.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [validationErrors, counter]);

  if (isOnlyOneError) {
    return (
      <Notification
        style={style}
        key={JSON.stringify({ counter, errors })}
        className={Object.values(errors)?.length ? 'element-vibration' : ''}
        status={Object.keys(validationErrors)?.[0]}
        content={
          <Typography variant="body2" emphasis="weak">
            {t('toContinuePlease')}{' '}
            <span style={{ textTransform: 'lowercase' }}>
              {validationErrors?.[Object.keys(validationErrors)?.[0]]?.[0]}
            </span>
          </Typography>
        }
      />
    );
  }

  return Object.keys(validationErrors)?.map(status => {
    return (
      <Notification
        style={style}
        status="warning"
        key={JSON.stringify({ status, counter, errors })}
        className={Object.values(errors)?.length ? 'element-vibration' : ''}
        content={
          <>
            <Typography variant="body2" emphasis="weak">
              {t('toContinuePlease')};
            </Typography>
            <CollectionsWarningList>
              {validationErrors[status]?.map((pageError, pageErrorIndex) => {
                return (
                  <CollectionsWarningListItem key={`page_error_${pageErrorIndex.toString()}`}>
                    <Typography variant="caption1" emphasis="weak">
                      {pageError}
                    </Typography>
                  </CollectionsWarningListItem>
                );
              })}
            </CollectionsWarningList>
          </>
        }
      />
    );
  });
}

export { ValidationErrors };

ValidationErrors.propTypes = {
  pageLayoutContentRef: PropTypes.shape({
    current: PropTypes.shape({
      scrollTo: PropTypes.func
    })
  }),
  style: PropTypes.object
};
